module.exports = __webpack_public_path__ + "img/icon_stock.9ec9d250.png";